module.exports = __webpack_public_path__ + "img/joyfulmovement-video@1x.8b458e65.png";